import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Ant Design
import {
    Card,
    Table,
    Input,
    Select,
    Tag,
    Avatar,
    Collapse,
    Progress,
    Space,
    Empty,
    Row,
    Col,
} from "antd";
import { UserOutlined, HomeOutlined, CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";

// Bootstrap
import { Breadcrumb, Tabs, Tab } from "react-bootstrap";

// Store
import { fetchTasks, tasksApprove, myTasks } from "@/store/tasksApi/tasksThunk";

// Utils
import formatDate from "../utils/formatDate";
import truncateChars from "../utils/cutWords";

const { Option } = Select;
const { Panel } = Collapse;

const statusMap = {
    pending: { label: "Kutilmoqda", color: "default" },
    in_progress: { label: "Jarayonda", color: "orange" },
    submitted: { label: "Tasdiqlashda", color: "blue" },
    approved: { label: "Tasdiqlangan", color: "green" },
    rejected: { label: "Qaytarilgan", color: "red" },
};

const TasksList = () => {
    const [activeKey, setActiveKey] = useState(
        localStorage.getItem("activeTab") || "given_tasks"
    );

    const dispatch = useDispatch();
    const { tasks, tasksApproveList, myTasksList } = useSelector(
        (state) => state.tasksApi
    );

    useEffect(() => {
        if (activeKey === "given_tasks") {
            dispatch(fetchTasks());
        } else if (activeKey === "control_tasks") {
            dispatch(tasksApprove());
        } else if (activeKey === "my_tasks") {
            dispatch(myTasks());
        }
    }, [dispatch, activeKey]);

    // Handle paginated response (new format) or array (old format)
    const tasksArray = Array.isArray(tasks)
        ? tasks
        : (tasks?.items || []);

    const tasksApproveArray = Array.isArray(tasksApproveList)
        ? tasksApproveList
        : (tasksApproveList?.items || []);

    const myTasksArray = Array.isArray(myTasksList)
        ? myTasksList
        : (myTasksList?.items || []);

    // Filters
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const [searchApprove, setSearchApprove] = useState("");
    const [statusFilterApprove, setStatusFilterApprove] = useState("");

    const [searchMy, setSearchMy] = useState("");
    const [statusFilterMy, setStatusFilterMy] = useState("");

    // Filtering
    const filteredTasks = tasksArray
        .filter((item) => (statusFilter ? item.status === statusFilter : true))
        .filter((item) =>
            search ? item.title.toLowerCase().includes(search.toLowerCase()) : true
        );

    const filteredTasksApprove = tasksApproveArray
        .filter((item) =>
            statusFilterApprove ? item.status === statusFilterApprove : true
        )
        .filter((item) =>
            searchApprove
                ? item.title.toLowerCase().includes(searchApprove.toLowerCase())
                : true
        );

    const filteredMyTasks = myTasksArray
        .filter((item) => (statusFilterMy ? item.status === statusFilterMy : true))
        .filter((item) =>
            searchMy
                ? item.title.toLowerCase().includes(searchMy.toLowerCase())
                : true
        );

    const handleTabChange = (key) => {
        setActiveKey(key);
        localStorage.setItem("activeTab", key);
    };

    const taskColumns = [
        {
            title: "№",
            dataIndex: "id",
            width: 60,
            render: (_, __, index) => index + 1,
        },
        {
            title: "Topshiriq nomi",
            dataIndex: "title",
            width: 250,
            render: (text, record) => (
                <Link to={`/tasks/detail/${record.id}`} style={{ fontWeight: 500 }}>
                    {text}
                </Link>
            ),
        },
        {
            title: "Tavsif",
            dataIndex: "description",
            render: (text) => (
                <div style={{ maxWidth: 300 }}>{truncateChars(text, 150)}</div>
            ),
        },
        {
            title: "Tayinlangan",
            dataIndex: "assigned_user",
            width: 180,
            render: (user) => user ? (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <Avatar
                        src={user.picture || undefined}
                        icon={!user.picture && <UserOutlined />}
                        size="small"
                    />
                    <span>{user.name || `${user.first_name} ${user.surname}`}</span>
                </div>
            ) : "-",
        },
        {
            title: "Holati",
            dataIndex: "status",
            width: 140,
            render: (status) => {
                const st = statusMap[status] || { label: status, color: "default" };
                return <Tag color={st.color}>{st.label}</Tag>;
            },
        },
        {
            title: "Yaratilgan",
            dataIndex: "created_at",
            width: 120,
            render: (date) => (
                <div style={{ fontSize: "0.9em" }}>
                    <CalendarOutlined style={{ marginRight: 4 }} />
                    {formatDate(date)}
                </div>
            ),
        },
        {
            title: "Muddat",
            dataIndex: "deadline",
            width: 120,
            render: (date) => (
                <div style={{ fontSize: "0.9em", color: new Date(date) < new Date() ? "#ff4d4f" : "inherit" }}>
                    <ClockCircleOutlined style={{ marginRight: 4 }} />
                    {formatDate(date)}
                </div>
            ),
        },
    ];

    return (
        <div className="container-fluid p-4">
            <Breadcrumb className="mb-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                    <HomeOutlined />
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Topshiriqlar</Breadcrumb.Item>
            </Breadcrumb>

            <Tabs
                activeKey={activeKey}
                onSelect={handleTabChange}
                className="mb-4"
            >
                {/* 1-tab: Kelib tushgan topshiriqlar */}
                <Tab
                    eventKey="given_tasks"
                    title={`Kelib tushgan topshiriqlar (${filteredTasks.length})`}
                >
                    <Card>
                        <Space style={{ marginBottom: 16 }} wrap>
                            {/*<Select*/}
                            {/*    placeholder="Holat bo'yicha"*/}
                            {/*    style={{ width: 200 }}*/}
                            {/*    allowClear*/}
                            {/*    value={statusFilter || undefined}*/}
                            {/*    onChange={(value) => setStatusFilter(value || "")}*/}
                            {/*>*/}
                            {/*    {Object.entries(statusMap).map(([key, value]) => (*/}
                            {/*        <Option key={key} value={key}>*/}
                            {/*            {value.label}*/}
                            {/*        </Option>*/}
                            {/*    ))}*/}
                            {/*</Select>*/}
                            <Input.Search
                                placeholder="Qidirish..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{ width: 250 }}
                            />
                        </Space>

                        {filteredTasks?.length > 0 ? (
                            <Table
                                dataSource={filteredTasks}
                                columns={taskColumns}
                                rowKey="id"
                                bordered
                                pagination={{ pageSize: 10, showSizeChanger: true }}
                                scroll={{ x: 1200 }}
                            />
                        ) : (
                            <Empty description="Ma'lumot topilmadi" />
                        )}
                    </Card>
                </Tab>

                {/* 2-tab: Nazorat qilinadigan topshiriqlar */}
                <Tab
                    eventKey="control_tasks"
                    title={`Nazorat qilinadigan topshiriqlar (${filteredTasksApprove.length})`}
                >
                    <Card>
                        <Space style={{ marginBottom: 16 }} wrap>
                            {/*<Select*/}
                            {/*    placeholder="Holat bo'yicha"*/}
                            {/*    style={{ width: 200 }}*/}
                            {/*    allowClear*/}
                            {/*    value={statusFilterApprove || undefined}*/}
                            {/*    onChange={(value) => setStatusFilterApprove(value || "")}*/}
                            {/*>*/}
                            {/*    {Object.entries(statusMap).map(([key, value]) => (*/}
                            {/*        <Option key={key} value={key}>*/}
                            {/*            {value.label}*/}
                            {/*        </Option>*/}
                            {/*    ))}*/}
                            {/*</Select>*/}
                            <Input.Search
                                placeholder="Qidirish..."
                                value={searchApprove}
                                onChange={(e) => setSearchApprove(e.target.value)}
                                style={{ width: 250 }}
                            />
                        </Space>

                        {filteredTasksApprove?.length > 0 ? (
                            <Collapse
                                accordion
                                style={{
                                    backgroundColor: "white",
                                    border: "none"
                                }}
                            >
                                {filteredTasksApprove?.map((task, index) => (
                                    <Panel
                                        header={
                                            <Row gutter={[16, 8]} align="middle" style={{ width: "100%" }}>
                                                <Col xs={24} sm={12} md={8}>
                                                    <div style={{ fontWeight: 500, fontSize: "1em" }}>
                                                        {task.title}
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={6} md={6}>
                                                    <div style={{ fontSize: "1em", color: "#666" }}>
                                                        <CalendarOutlined style={{ marginRight: 4 }} />
                                                        Yaratilgan: {formatDate(task.created_at)}
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={6} md={6}>
                                                    <div style={{
                                                        fontSize: "1em",
                                                        color: new Date(task.deadline) < new Date() ? "#ff4d4f" : "#666"
                                                    }}>
                                                        <ClockCircleOutlined style={{ marginRight: 4 }} />
                                                        Muddat: {formatDate(task.deadline)}
                                                    </div>
                                                </Col>
                                                <Col xs={24} sm={12} md={4} style={{ textAlign: "right" }}>
                                                    <Avatar.Group maxCount={3}>
                                                        {task.assigned_users?.map((user) => (
                                                            <Avatar
                                                                key={user.id}
                                                                src={user.picture || undefined}
                                                                icon={!user.picture && <UserOutlined />}
                                                            />
                                                        ))}
                                                    </Avatar.Group>
                                                </Col>
                                            </Row>
                                        }
                                        key={index}
                                        style={{
                                            backgroundColor: "white",
                                            marginBottom: 8,
                                            border: "1px solid #d9d9d9",
                                            borderRadius: 4
                                        }}
                                    >
                                        <div style={{ padding: "0 16px 16px" }}>
                                            <p style={{ marginBottom: 16 }}>
                                                <strong>Tavsif: </strong>
                                                {task.description || "Tavsif yo'q"}
                                            </p>

                                            <Table
                                                size="small"
                                                dataSource={task.assigned_users}
                                                rowKey="id"
                                                pagination={false}
                                                bordered
                                                columns={[
                                                    {
                                                        title: "№",
                                                        width: 50,
                                                        render: (_, __, idx) => idx + 1,
                                                    },
                                                    {
                                                        title: "FIO",
                                                        render: (u) => (
                                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                <Avatar
                                                                    src={u.picture || undefined}
                                                                    icon={!u.picture && <UserOutlined />}
                                                                    size="small"
                                                                />
                                                                <Link to={`/tasks/approve-detail/${u.task_id}`}>
                                                                    {u.first_name} {u.surname} {u.patronymic}
                                                                </Link>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "Holati",
                                                        dataIndex: "task_status",
                                                        width: 140,
                                                        render: (st) => {
                                                            const map = statusMap[st] || { label: st, color: "default" };
                                                            return <Tag color={map.color}>{map.label}</Tag>;
                                                        },
                                                    },
                                                    {
                                                        title: "Jarayon",
                                                        width: 150,
                                                        render: (u) => {
                                                            let now =
                                                                u.steps_count > 0
                                                                    ? (u.completed_steps_count / u.steps_count) * 100
                                                                    : 0;
                                                            if (u.task_status === "pending") now = 0;
                                                            return (
                                                                <Progress
                                                                    percent={Math.round(now)}
                                                                    size="small"
                                                                    status={now === 100 ? "success" : "active"}
                                                                />
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </Panel>
                                ))}
                            </Collapse>
                        ) : (
                            <Empty description="Ma'lumot topilmadi" />
                        )}
                    </Card>
                </Tab>
            </Tabs>
        </div>
    );
};

export default TasksList;